import React, { useEffect, useRef } from 'react'
import { string, node, func, bool, number } from 'prop-types'
import tick from './assets/tick.svg'
import georgeTick from './assets/george-tick.svg'

const Button = ({
  id,
  className,
  onClick,
  children,
  loading,
  type,
  analytics,
  saved,
  setSaved,
  isGeorgeUser,
  tabOrder,
  disabled,
  setPrevFocusableElement,
}) => {
  const onClickWithAnalyticsFire = () => {
    onClick()
    analytics()
  }
  const handleTimeout = () => {
    setSaved(false)
  }
  useEffect(() => {
    setTimeout(() => {
      handleTimeout()
    }, 3900)
  }, [saved])

  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    setPrevFocusableElement && setPrevFocusableElement(element)
  })

  const tickIcon = isGeorgeUser ? georgeTick : tick
  return (
    <button
      onClick={analytics ? onClickWithAnalyticsFire : onClick}
      id={id}
      className={className}
      disabled={loading || saved || disabled}
      type={type}
      tabIndex={tabOrder}
      aria-live="polite"
      ref={ref}
    >
      { loading ? <Loader /> : null }
      { saved ? <Saved tickIcon={tickIcon} /> : null }
      { !loading && !saved ? children : null }
    </button>
  )
}

Button.propTypes = {
  children: node,
  onClick: func,
  className: string,
  loading: bool,
  type: string,
  id: string,
  analytics: func,
  saved: bool,
  setSaved: func,
  isGeorgeUser: bool,
  tabOrder: number,
  disabled: bool,
  setPrevFocusableElement: func
}

Button.defaultProps = {
  children: null,
  onClick: () => {},
  className: '',
  loading: false,
  type: 'submit',
  id: '',
  analytics: null,
  saved: false,
  setSaved: x => x,
  isGeorgeUser: false,
  tabOrder: 0,
  disabled: false,
}

const Loader = () => (
  <div id="loading" aria-label="loading">
    <div className="animation">
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
    </div>
  </div>
)

const Saved = ({ tickIcon }) => (
  <span className="saved">
    <img src={tickIcon} alt="" className="tick" />
    <span role="alert" className="saved-text">Saved</span>
  </span>
)

Saved.propTypes = {
  tickIcon: string.isRequired,
}

export default Button
